/**
 * Spotify domain — V6 feature. Spawns `spotdl` to download tracks/playlists
 * from a user-supplied Spotify URL. A job queue tracks progress.
 */
import { z } from "zod";
export const SpotifyImportBodySchema = z.object({
    url: z
        .string()
        .url()
        .refine((u) => /(^https?:\/\/open\.spotify\.com\/(track|playlist|album)\/)|(spotify:(track|playlist|album):)/.test(u), { message: "Must be a Spotify track, playlist, or album URL" }),
    owner: z.string().min(1),
});
export const SpotifyJobStatusSchema = z.enum([
    "queued",
    "running",
    "completed",
    "failed",
    "cancelled",
]);
export const SpotifyJobEventSchema = z.discriminatedUnion("type", [
    z.object({ type: z.literal("log"), line: z.string() }),
    z.object({ type: z.literal("progress"), completed: z.number(), total: z.number().nullable() }),
    z.object({ type: z.literal("status"), status: SpotifyJobStatusSchema }),
    z.object({ type: z.literal("track-added"), trackId: z.number() }),
    z.object({ type: z.literal("track-skipped"), trackId: z.number() }),
    z.object({ type: z.literal("track-updated"), trackId: z.number() }),
    z.object({ type: z.literal("track-removed"), trackId: z.number() }),
    z.object({
        type: z.literal("sync-summary"),
        added: z.number(),
        updated: z.number(),
        skipped: z.number(),
        removed: z.number(),
    }),
    z.object({ type: z.literal("error"), message: z.string() }),
    z.object({ type: z.literal("done") }),
]);
//# sourceMappingURL=spotify.js.map